import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Seo from "@/components/Seo";

export default function PaymentSuccess() {
  const navigate = useNavigate();
  useEffect(() => {
    navigate("/#products", { replace: true });
  }, [navigate]);
  return <Seo title="Order status | Lab2o" path="/payment/success" description="Order status." noindex />;
}
